import React, { Component } from 'react';
import ScreensaverComponent from './component';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class ScreensaverListContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      imageList: [],
      showImageList: [],
      limit:1000,
      offset:0,
    };
  }
  componentDidMount() {
    this.setState(prev => ({
      loading: true
    }));
    
    this.props.getDataFromAPI(
      `/screensaver/all?limit=${this.state.limit}&offset=${this.state.offset}`,
      'GET',
      undefined,
      response => {
        this.setState(prev =>({
         imageList: response.list,
         showImageList: response.list,
         loading: false 
        }));
      },
      err => {
        toastr.error('ERROR', err);
        console.log(err);
        this.setState(prev =>({
          loading: false
        }))
      }
    );
  }
  onClickOnAddNew = () => {
    this.props.history.push('/vendingmachines/rc/screensaver/new');
  }
  onClickOnEdit = (imageId) => {
    this.props.history.push(`/vendingmachines/rc/screensaver/update/${imageId}`);
  }
  onClickOnDelete = (imageId,imagePath) => {
    if (!confirm(`Are you sure you want to delete "${imagePath}"`)) {
      return;
    }
    this.props.getDataFromAPI(
      `/screensaver/delete?imageId=${imageId}`,
      'DELETE',
      undefined,
      response => {
       const newImageList = this.state.showImageList.filter(image => image.id !== imageId )
       this.setState(prev => ({
        imageList : newImageList,
        showImageList : newImageList
       }));
      },
      err => {
        toastr.error('ERROR', err.messages);
        console.log(err);
      }
    );
  }

  onChangeOnSearchName = (e,data) =>{
    const regex = new RegExp(data.value,'i');    
    const newList=this.state.imageList.filter(image => 
       image.screen_saver_url.split('/')[1].match(regex)
    );
    
    this.setState(prev => ({
      showImageList: newList
    }))
    
  }

  render() {
    return (
      <ScreensaverComponent
        loading={this.state.loading}
        showImageList={this.state.showImageList}
        onClickOnAddNew={this.onClickOnAddNew}
        onClickOnDelete={this.onClickOnDelete}
        onClickOnEdit= {this.onClickOnEdit}
        onChangeOnSearchName={this.onChangeOnSearchName}
      />
    );
  }
}

export default withRouter(connect(null,{getDataFromAPI})(ScreensaverListContainer));


// WEBPACK FOOTER //
// ./src/Modules/ImageList/container.jsx